import React from "react";

export default function DateTimeField({ field, value, onChange }) {
  return (
    <div className="mp-form-group">
      <label className="mp-form-label">{field._label}{field.required && " *"}</label>
      <input
        type="datetime-local"
        className="mp-form-input"
        value={value ?? ""}
        onChange={e => onChange(field.name, e.target.value)}
      />
    </div>
  );
}
